export interface IStatusList {
    active: boolean,
    inactive: boolean,
    donated: boolean,
    deleted: boolean
}

